<template>
	<div class="list">
		<div v-for="item in items" :key="item" class="list-item">
			<div class="list-item--icon">
				<svg
					v-if="!outlinedIcons"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<circle cx="12" cy="12" r="12" :fill="iconColor" />
					<path
						d="M17.1 7.80005L12.3403 15.4684C12.0085 16.003 11.2713 16.102 10.8102 15.6738L7.5 12.6"
						stroke="white"
						stroke-width="2"
						stroke-linecap="round"
					/>
				</svg>

				<svg v-else width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						:stroke="iconColor"
						d="M10.6 1.1499L5.84033 8.81826C5.50851 9.35286 4.77132 9.45184 4.31024 9.02369L1 5.9499"
						stroke-width="2"
						stroke-linecap="round"
					/>
				</svg>
			</div>
			<div class="list-item--text">{{ item }}</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	items: {
		type: Array,
		default: () => []
	},

	outlinedIcons: {
		type: Boolean,
		default: true
	},

	iconColor: {
		type: String,
		default: '#77AC56'
	}
})
</script>

<style lang="scss" scoped>
.list {
	&-item {
		display: flex;
		margin-bottom: 0.8rem;

		&:last-child {
			margin-bottom: 0;
		}

		&--icon {
			width: 1.6rem;
			margin: auto 0;
			svg {
				width: 100%;
				display: block;
			}
		}

		&--text {
			font-size: 1.2rem;
			margin-left: 0.8rem;
			color: #323653;
			width: calc(100% - 1.6rem);
		}
	}
}
</style>
